import { get } from '../helpers'

export default {
  fetchUnitsSold({ country, name, selectedDays }) {
    const path = `api/keywords/get_graph_data?country=${country}&name=${encodeURIComponent(
      name
    )}&type=units_sold&selectedDays=${selectedDays}`
    return get(path)
  }
}
